module.exports = __webpack_public_path__ + "img/schmiedeeisen.833043e7.webp";